import { Collapse, CollapsibleIconButton, styled, Typography, useBreakpointDown } from '@chronosphereio/chrono-ui';
import { ReactNode } from 'react';

export interface CollapsibleSectionProps {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  children: ReactNode;
}

export function CollapsibleSection({ title, expanded, onToggle, children }: CollapsibleSectionProps) {
  const isMobile = useBreakpointDown('sm', { breakpointSource: 'viewport' });

  return isMobile ? (
    <div>
      <CollapsibleSectionHeader onClick={onToggle}>
        <CollapsibleIconButton collapsed={!expanded} ariaLabelSubject={title} />
        <Typography fontWeight="bold" color={(t) => t.palette.text.primary}>
          {title}
        </Typography>
      </CollapsibleSectionHeader>
      <Collapse in={expanded} unmountOnExit>
        {children}
      </Collapse>
    </div>
  ) : (
    <>{children}</>
  );
}

const CollapsibleSectionHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1, 0),
  cursor: 'pointer',
  position: 'sticky',
  top: 0,
  // input labels were floating over the section header, so we need to set a higher z-index
  // we really only needed to bump the z-index up a bit because the base seems to have a z-index of 1
  zIndex: 2,
  backgroundColor: theme.palette.background.popover,
  // sc-164282
  // we can get rid of the pseudo element once the feature flag is flipped and put the hover
  // state background on the header directly
  '&:hover::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    backgroundColor: theme.palette.action.hover,
    pointerEvents: 'none',
  },
}));
